/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useRef } from 'react';
export var useTwoSecondsLoading = function useTwoSecondsLoading(options) {
  var requestFinished = useRef(false);
  var takeTwoSeconds = useRef(false);
  var timeout = useRef();
  var setLoading = options.setLoading;
  var handleTwoSecondLoading = function handleTwoSecondLoading(actualLoading) {
    if (actualLoading) {
      setLoading && setLoading(true);
      // Request start
      timeout.current = setTimeout(function () {
        takeTwoSeconds.current = true;
        // After 2s, if the reqeust is already finished, should manually stop loading
        // Otherwise should wait for request finished
        if (requestFinished.current) {
          setLoading && setLoading(false);
          takeTwoSeconds.current = false;
          requestFinished.current = false;
        }
      }, 2000);
    } else {
      // Request complete
      requestFinished.current = true;
      // When request complete, if it takes 2s or more, should manually stop loading
      // Otherwise should wait for 2s
      if (takeTwoSeconds.current) {
        setLoading && setLoading(false);
        takeTwoSeconds.current = false;
        requestFinished.current = false;
      }
    }
  };
  return {
    handleTwoSecondLoading: handleTwoSecondLoading,
    timeout: timeout
  };
};